import styled from 'styled-components';

export const Label = styled.label`
  font-weight: 700;
  color: ${({ theme }) => theme.color.darkGrey};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;
